export type FAQItem = {
  question: string
  answer: string
  category: string
}

export const faqs: FAQItem[] = [
  // Workshops
  {
    category: 'Workshops',
    question: 'Moet ik ervaring hebben om deel te nemen?',
    answer:
      'Nee, de meeste van onze workshops zijn geschikt voor beginners, tenzij specifiek anders vermeld. Onze docenten begeleiden je stap voor stap.',
  },
  {
    category: 'Workshops',
    question: 'Wat als ik ziek ben of niet kan komen?',
    answer:
      'Bij annulering tot 14 dagen voor aanvang krijg je het inschrijvingsgeld terug (min €5 administratiekosten). Binnen 14 dagen is terugbetaling niet mogelijk, maar je mag wel iemand anders in jouw plaats laten komen.',
  },
  {
    category: 'Workshops',
    question: 'Zijn alle materialen inbegrepen?',
    answer:
      'Ja, voor de meeste workshops zijn alle materialen inbegrepen in de prijs. Als je zelf iets moet meebrengen, staat dit duidelijk vermeld bij de workshopomschrijving.',
  },

  // Maekerscafés
  {
    category: 'Maekerscafés',
    question: 'Moet ik mij inschrijven voor een Maekerscafé?',
    answer:
      'Inschrijven is niet verplicht, maar wel handig voor ons zodat we weten hoeveel mensen we kunnen verwachten. Je kunt gewoon binnenlopen.',
  },
  {
    category: 'Maekerscafés',
    question: 'Wat kost deelname aan een Maekerscafé?',
    answer:
      'Deelname is gratis! We vragen wel om een drankje te bestellen aan onze bar om onze werking te steunen.',
  },
  {
    category: 'Maekerscafés',
    question: 'Moet ik materiaal meebrengen naar een Maekerscafé?',
    answer:
      'Ja, breng je eigen project en materialen mee. Basisgereedschap is wel aanwezig. Kijk bij het specifieke thema wat je nodig hebt.',
  },

  // Koffiebar
  {
    category: 'Koffiebar',
    question: 'Moet ik een workshop volgen om de koffiebar te bezoeken?',
    answer:
      'Nee, de koffiebar is vrij toegankelijk voor iedereen. Je bent welkom om gewoon langs te komen voor een koffie, te werken op je laptop of af te spreken met vrienden.',
  },
  {
    category: 'Koffiebar',
    question: 'Kan ik in de koffiebar werken met mijn laptop?',
    answer:
      'Absoluut! We hebben gratis WiFi en stopcontacten bij elke tafel. De koffiebar is een fijne plek om rustig te werken.',
  },
  {
    category: 'Koffiebar',
    question: 'Hebben jullie opties voor mensen met allergieën?',
    answer:
      'Ja, we hebben vegetarische, veganistische en glutenvrije opties. Onze menukaart bevat allergeneninformatie. Vraag gerust aan onze barista als je twijfelt.',
  },

  // Cadeaubonnen
  {
    category: 'Cadeaubonnen',
    question: 'Hoe lang is een cadeaubon geldig?',
    answer:
      'Onze cadeaubonnen zijn 1 jaar geldig na aankoopdatum. De vervaldatum staat vermeld op de bon.',
  },
  {
    category: 'Cadeaubonnen',
    question: 'Kan ik een cadeaubon gebruiken voor elke workshop?',
    answer:
      'Ja, cadeaubonnen zijn geldig voor alle workshops in ons aanbod. Je kunt de unieke code ingeven bij het boeken.',
  },
  {
    category: 'Cadeaubonnen',
    question: 'Wat als de workshop duurder is dan mijn cadeaubon?',
    answer:
      'Je kunt het verschil bijbetalen bij het boeken. Is de workshop goedkoper, dan blijft het restbedrag op de bon staan voor een volgende boeking.',
  },

  // Locatie
  {
    category: 'Locatie',
    question: 'Kan ik de ruimte huren voor een privéfeest?',
    answer:
      'Zeker! Onze ruimte is te huur voor vergaderingen, teambuildings, workshops en privéfeestjes. Kijk op de pagina "Locatie huren" voor meer info en prijzen.',
  },
  {
    category: 'Locatie',
    question: 'Is er parkeergelegenheid in de buurt?',
    answer:
      'Ja, er is voldoende parkeergelegenheid in de omliggende straten (betalend) en op wandelafstand zijn er enkele publieke parkings.',
  },

  // Algemeen
  {
    category: 'Algemeen',
    question: 'Kan ik met kaart betalen?',
    answer:
      'Ja, in onze koffiebar en shop kun je betalen met Bancontact, Payconiq en cash.',
  },
  {
    category: 'Algemeen',
    question: 'Zijn jullie toegankelijk voor rolstoelgebruikers?',
    answer:
      'Ja, onze benedenverdieping (koffiebar en grote workshopruimte) is volledig toegankelijk. Er is ook een aangepast toilet aanwezig.',
  },
]
